//Global
window.ontech = window.ontech || {};
window.ontech.analytics = window.ontech.analytics || {};

const DataModel = {
    CART_TOTAL_ITEMS: 'cart_total_items',
    CART_TOTAL_VALUE: 'cart_total_value',
    CONTENT_CATEGORY: 'content_category',
    COUNTRY_CODE: 'country_code',
    CURRENCY: 'currency',
    CUSTOMER_LOGGED_IN: 'customer_logged_in',
    CUSTOMER_CITY: 'customer_city',
    CUSTOMER_EMAIL: 'customer_email',
    CUSTOMER_FIRST_NAME: 'customer_first_name',
    CUSTOMER_ID: 'customer_id',
    CUSTOMER_LAST_NAME: 'customer_last_name',
    CUSTOMER_STATE: 'customer_state',
    CUSTOMER_ZIP: 'customer_zip',
    DEVICE_TYPE: 'device_type',
    EVENT: 'event',
    FILTER_COUNT: 'filter_count',
    LANGUAGE_CODE: 'language_code',
    MEMBERSHIP_EXISTING: 'membership_existing',
    ORDER_ID: 'order_id',
    ORDER_COUPON_CODE: 'order_coupon_code',
    ORDER_TOTAL: 'order_total',
    ORDER_SHIPPING: 'order_shipping',
    PAGE_NAME: 'page_name',
    PAGE_TYPE: 'page_type',
    PHOTO_NAME: 'photo_name',
    PRODUCT_BRAND: 'product_brand',
    PRODUCT_CATEGORY: 'product_category',
    PRODUCT_DISCOUNT: 'product_discount',
    PRODUCT_ID: 'product_id',
    PRODUCT_NAME: 'product_name',
    PRODUCT_PRICE: 'product_price',
    PRODUCT_QUANTITY: 'product_quantity',
    PRODUCT_SKU: 'product_sku',
    PRODUCT_TYPE: 'product_type',
    PRODUCT_UNIT_PRICE: 'product_unit_price',
    PRODUCT_VARIANT_ID: 'product_var_id',
    SCHEDULE_DAYS: 'schedule_days',
    SCHEDULE_TIME: 'schedule_time',
    SELECTED_FILTER: 'selected_filters',
    SHIPPING_METHOD: 'shipping_method',
    SITE_SECTION: 'site_section',
    VARIANT_ID: 'variant_ids',
    VARIANT_PRICES: 'variant_prices'
}

// required for slide cart operation
window.removeItemAnalytics = function(cart) {
    if (isUndefinedOrNull(cart.brand)) {
        cart.brand = '';
    }

    if (isUndefinedOrNull(cart.price)) {
        cart.price = 0.0;
    }

    if (isUndefinedOrNull(cart.currency)) {
        cart.currency = '';
    }

    sendAnalytics("cart_remove", {
        [DataModel.PRODUCT_TYPE]: "product",
        [DataModel.PRODUCT_CATEGORY]: "Product",
        [DataModel.PRODUCT_ID]: [cart.id],
        [DataModel.PRODUCT_NAME]: [cart.name],
        [DataModel.PRODUCT_BRAND]: [cart.brand],
        [DataModel.PRODUCT_QUANTITY]: [cart.quantity],
        [DataModel.PRODUCT_SKU]: [cart.sku],
        [DataModel.PRODUCT_PRICE]: [cart.price],
        [DataModel.CURRENCY]: [cart.currency],
        [DataModel.VARIANT_ID]: [cart.variantId],
        [DataModel.PAGE_TYPE]: "remove_from_cart"
    });
}

async function launchRemoveAnalytics(e, el) {
    let tmpCart, cart, firstElement, index;
    tmpCart = await ontech.getCart()
        .catch(err => {
            ontech.log.error(`$$$ Analytics Link Error in launchRemoveAnalytics(), failed to get cart: ${err}`, err);
            // Stop flow since this is needed for the rest of the function
            throw err;
        });
    firstElement = $(el)[0];
    index =
        tmpCart.items
            .findIndex(element => element.id === toInteger(firstElement.dataset.productVariantId))
    cart = {
        id: firstElement.dataset.productId,
        name: firstElement.dataset.productName,
        brand: firstElement.dataset.productBrand,
        quantity: tmpCart.items[index].quantity,
        sku: firstElement.dataset.productSku,
        variantId: firstElement.dataset.productVariantId,
        price: tmpCart.items[index].line_price / 100.00,
        currency: tmpCart.currency,
    };
    window.removeItemAnalytics(cart);
}

function sendAnalytics(event, data = {}){
    sendAdobePayload(event, data);
}

function buildDataLayer(){
    buildAdobeDataLayer();
}

function sendAdobePayload(event, data) {
    if (isUndefinedOrNull(window.eventTrack)) {
        window.ontech.log.error(
            'Cannot send analytics data to adobe. eventTrack is undefined.', data);
        return;
    }

    window.eventTrack({
        [DataModel.EVENT]: event,
        ...data
    });
}

function buildAdobeDataLayer(){
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
        ... window.ontech.analytics
    });
}